export default "__VITE_ASSET__BoSRzbQa__"